import axios from 'axios';
import Environment from '../../utils/Environment';

interface StopStatusParams {
  dcCode: string;
  shipmentIds: string | string[];
}

const getStopStatus = async (params: StopStatusParams): Promise<string> => {
  try {
    // Get API URL from environment configuration
    const baseUrl = Environment.getStopStatusAPI();
    if (!baseUrl) {
      console.error('REACT_APP_STOP_STATUS_API is not configured');
      return 'Error';
    }
    
    // Validate required parameters
    if (!params.dcCode || !params.shipmentIds) {
      console.error('Missing required parameters - dcCode or shipmentIds');
      return 'Error';
    }
    
    // Handle shipmentIds as either string or array
    const shipmentIdsParam = Array.isArray(params.shipmentIds) 
      ? params.shipmentIds.join(',')
      : params.shipmentIds;
    
    const apiUrl = `${baseUrl}?dcCode=${encodeURIComponent(params.dcCode)}&shipmentIds=${encodeURIComponent(shipmentIdsParam)}`;
    
    const response = await axios.get(apiUrl);
    
    // Handle different response formats from the API
    if (response.data) {
      // If response is an object with status property
      if (typeof response.data === 'object' && response.data.status) {
        return response.data.status;
      }
      // If response is an array of objects, get the first one's status
      if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].status) {
        return response.data[0].status;
      }
      // If response is a string
      if (typeof response.data === 'string') {
        return response.data;
      }
      // If response has other object structures, try to extract status
      if (response.data.shipmentID && response.data.status) {
        return response.data.status;
      }
    }
    
    // Fallback to Unknown if we can't extract the status
    return 'Unknown';
  } catch (error) {
    console.error('Error fetching stop status:', error);
    // Return a default status on error
    return 'Error';
  }
};

export default getStopStatus;